import { useContext } from "react";

import { DocumentsPanelContext } from "./DocumentsPanelContext";

export function useDocumentsPanel() {
  const context = useContext(DocumentsPanelContext);
  if (!context) {
    throw new Error("useDocumentsPanel must be used within a DocumentsPanelProvider");
  }
  return context;
}
